(function () {
  'use strict';

  function initFaqsPage() {
    var root = document.querySelector('#MainContent .gvfg-faq, .gvfg-faq-section-wrapper .gvfg-faq, #gvfgFaqsPage');
    if (!root || root.dataset.gvfgFaqsInit === '1') return;
    root.dataset.gvfgFaqsInit = '1';
    root.classList.add('gvfg-faq--enhanced');

    var reveals = root.querySelectorAll('.gvfg-faq-reveal');
    function showReveal(el) {
      el.classList.add('is-visible');
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              showReveal(e.target);
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -20px 0px' }
      );
      reveals.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.92) showReveal(el);
        io.observe(el);
      });
    } else {
      reveals.forEach(showReveal);
    }
    setTimeout(function () {
      reveals.forEach(showReveal);
    }, 1200);

    var hero = root.querySelector('.gvfg-faq-hero');
    if (hero) {
      requestAnimationFrame(function () { hero.classList.add('is-visible'); });
    }

    root.querySelectorAll('.gvfg-faq-3d-card').forEach(function (card) {
      var inner = card.querySelector('.gvfg-faq-3d-card__inner');
      if (!inner) return;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        inner.style.transform =
          'rotateX(' + (-y * 14) + 'deg) rotateY(' + (x * 14) + 'deg) translateZ(12px)';
      });
      card.addEventListener('mouseleave', function () {
        inner.style.transform = '';
      });
    });

    root.querySelectorAll('.gvfg-faq-nav__pill').forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        var id = pill.getAttribute('data-section');
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          root.querySelectorAll('.gvfg-faq-nav__pill').forEach(function (p) {
            p.classList.remove('is-active');
          });
          pill.classList.add('is-active');
        }
      });
    });

    root.querySelectorAll('.gvfg-faq-acc-item').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        var group = item.closest('[data-faq-group]');
        var scope = group || root;
        scope.querySelectorAll('.gvfg-faq-acc-item[open]').forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });

    root.querySelectorAll('a[href^="#gvfg-faq-"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  window.gvfgInitFaqsPage = function (force) {
    if (force) {
      document.querySelectorAll('.gvfg-faq').forEach(function (el) {
        delete el.dataset.gvfgFaqsInit;
      });
    }
    initFaqsPage();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqsPage);
  } else {
    initFaqsPage();
  }

  document.addEventListener('shopify:section:load', initFaqsPage);
})();